import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import RowSection from './RowSection';

function ListSection({ title, items, className, style, isFavorite, showIconFav, onClickFavoriteFunc, isSelectedFunc }) {
  const storeRoute = useSelector(state => state.storeRoute);
  const setHistory = useCallback((to) => () => {
    storeRoute.goTo(to);
  }, [storeRoute])
  return (
    <>
      <div className={'flexRow genres-list-section-title'}>
        <span className={`type-medium fz12`}>{title}</span>
      </div>
      <div className={`flexColumn genres-list-section ${className}`} style={style}>
        { items && items.map( item =>
          <RowSection key={`genre-${item.slug}`} name={item.name}
            isSelected={ isSelectedFunc && isSelectedFunc(item.slug)}
            onClickTo={setHistory(`/genres/${item.slug}/featured`)} 
            isFavorite={isFavorite}
            showIconFav={showIconFav}
            onClickFavorite={ onClickFavoriteFunc && onClickFavoriteFunc(item.id, item.name)}
            className={"genre-list-section-row"}
          />
        )}
      </div>
    </>
  )
}

ListSection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  isFavorite: PropTypes.bool, 
  showIconFav: PropTypes.bool,
  onClickFavoriteFunc: PropTypes.func.isRequired
}

export default ListSection;
